<form
  class="update-record-dialog"
  [formGroup]="tagForm"
  (ngSubmit)="updateTag()"
>
  <section class="record-summary" aria-label="Tag context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-tag"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">Edit Tag</span>
      <h2>{{ tagForm.get('hotkey_tag')?.value || 'Tag details' }}</h2>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section__header">
      <h3>Tag details</h3>
    </div>

    <div class="form-grid">
      <div class="form-field">
        <label for="hotkeyTag">Tag</label>
        <input
          id="hotkeyTag"
          pInputText
          type="text"
          formControlName="hotkey_tag"
          maxlength="8"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="tagForm.get('hotkey_tag')?.hasError('required') && (tagForm.get('hotkey_tag')?.touched || tagForm.get('hotkey_tag')?.dirty)"
        >
          <strong>A tag</strong> is required
        </small>
        <small
          class="p-error"
          *ngIf="tagForm.get('hotkey_tag')?.hasError('maxlength')"
        >
          Tag must be 8 characters or fewer
        </small>
      </div>

      <div class="form-field">
        <label for="tagDescription">Tag Description</label>
        <input
          id="tagDescription"
          pInputText
          type="text"
          formControlName="tag_description"
          maxlength="100"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="tagForm.get('tag_description')?.hasError('required') && (tagForm.get('tag_description')?.touched || tagForm.get('tag_description')?.dirty)"
        >
          <strong>A tag description</strong> is required
        </small>
        <small
          class="p-error"
          *ngIf="tagForm.get('tag_description')?.hasError('maxlength')"
        >
          Description must be 100 characters or fewer
        </small>
      </div>
    </div>
  </section>

  <div class="dialog-actions">
    <button
      pButton
      type="submit"
      icon="pi pi-check"
      label="Update Tag"
      class="p-button-primary w-full"
      [loading]="loading"
    ></button>
  </div>
</form>
